module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_survey_remoteEntry_mjs_145a5681__;